import { IconNotes } from './IconNotes'
import React from 'react'
import { useAtomValue } from 'jotai'
import * as state from '../../../states'

type INotesIconBtn = {
	value: string | null
	onClick: (e: React.MouseEvent) => void
}

export const NotesIconBtn = ({
	value,
	onClick
}: INotesIconBtn) => {
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const isDataNotEmpty = typeof (value) === 'string' && value?.length > 0
	const fillColor = isDataNotEmpty ? 'var(--mainColor)' :
		isThemeDark ? 'var(--darkBodyColor)' : 'black'

	return (
		<i
			className={'icon-notes'}
			style={{
				padding: '7px',
				cursor: 'pointer'
			}}
			onClick={(e) => onClick && onClick(e)}
		>
			<IconNotes stroke={fillColor}/>
		</i>
	)
}